import { deserializeStorage, serializeStorage } from "./App";
import { copyImportCode } from "./Game";
import { gameName, maxGuesses } from "./util";
import React, { useRef, useEffect } from 'react';
import { Row, RowState } from "./Row";
import { Clue } from "./clue";

export async function pasteImportCode() {
  const enteredCode = prompt('Please paste your import code');
  if ( enteredCode !== null ) {
    deserializeStorage(enteredCode);
  }
}

export function About() {

  const isHttp = window.location.protocol === "http:";
  const importCodeRef = useRef<HTMLTextAreaElement>(null);

  const handleTextareaClick = () => {
    if (importCodeRef.current) {
      importCodeRef.current.select();
    }
  };

  useEffect(() => {
    if (importCodeRef.current) {
      importCodeRef.current.focus();
      importCodeRef.current.select();
    }
  }, []);

  let importLink = (
  <div>
  <hr/>
  <p><h2>Transferring game history to a new device or browser</h2></p>
  <p>
    <p>Click <button onClick={() =>{copyImportCode();}}>here</button> to copy an import code to your clipboard which you can use to transfer your stats to another device.</p>
    
    {isHttp && 
    <p>Note: You are on the non-secure site (http rather than https.) Non-secure sites can't access the clipboard. You have to manually copy it from the text area below with Ctrl+C or Cmd+C. It is recommended you do so and switch to the secure site <a href="https://double-dabble.com">https://double-dabble.com</a>
      <textarea id="import-code" className="import-code" readOnly rows={10} ref={importCodeRef} onClick={handleTextareaClick}>{serializeStorage()}</textarea>
    </p>
    }

    <p>Click <button onClick={() =>{pasteImportCode();}}>here</button> to paste an import code from your clipboard.</p>
  </p>
  </div>
  );

  return (
    <div className="App-about">
        <p>
          {gameName} is a variant of Wordle by Josh Wardle and is one of a number of sibling sites.{" "}
          <br /><br /> <a href="https://xordle.org">Xordle</a> by <a href="https://twitter.com/kellydornhaus">keldor</a><br/>Two secret words, one board, no overlap between the words. 
          <br /><br /> <a href="https://fibble.xyz">Fibble</a> by K &amp; R Garfield, coded by keldor <br/>Lies to you once per row.
          <br /><br /> <a href="https://double-dabble.com">Double-Dabble</a> by K &amp; R Garfield, coded by keldor <br/>Each letter is bound to another letter.
          <br /><br /> <a href="https://warmle.org">Warmle</a> by Mike Elliott, coded by keldor <br/>Yellows tell you if you've gotten close in that position.
          <br /><br /> <a href="https://shuntle.com">Shuntle</a> by LSK, coded by keldor<br/>The secret word is 4-7 letters long, with spaces on the left or right.
          <br /><br />Code based on a fork of <a href="https://github.com/lynn/hello-wordl">hello wordl</a>.
        </p>
      <hr />        
      <p className="App-instructions">
        <h1>Double-Dabble Rules!</h1>
        It certainly does.
        <br />You get {maxGuesses} tries to guess the secret word.
        <br /><b>The 26 letters are randomly paired, and you can only guess pairs of letters.</b>
        <br />
        <br />Letters in your guess are:
        <br />🟩 Green if either bound letter is in the right place.
        <br />🟨 Yellow if either bound letter is in the word somewhere else.
        <br />⬛ Grey if neither bound letter is in the word.
        <br />
        <br />For example, you might enter the pairs BD LR AF IS NT thinking of BLAST, although it works for DRAIN too, and possibly others.
        <br />If secret word is CLOUT then you would receive the following feedback:
        <br />   
            <Row
              onClick={() => {}}
              currentGuess={["", -1]}
              rowState={RowState.LockedIn}
              rowNumber={0}
              cluedRows={[]}
              cluedLetters={[
                { clue: Clue.Absent, letterPair: "BD" },
                { clue: Clue.Correct, letterPair: "LR" },
                { clue: Clue.Absent, letterPair: "AF" },
                { clue: Clue.Absent, letterPair: "IS" },
                { clue: Clue.Correct, letterPair: "NT" },
              ]}
              letterInfo={new Map()}
              rowWidth={5}
            />
        <br />However if the secret word was LABEL then you would receive:
        <Row
              currentGuess={["", -1]}
              onClick={() => {}}
              rowState={RowState.LockedIn}
              rowNumber={0}
              cluedRows={[]}
              cluedLetters={[
                { clue: Clue.Elsewhere, letterPair: "BD" },
                { clue: Clue.Elsewhere, letterPair: "LR" },
                { clue: Clue.Elsewhere, letterPair: "AF" },
                { clue: Clue.Absent, letterPair: "IS" },
                { clue: Clue.Absent, letterPair: "NT" },
              ]}
              letterInfo={new Map()}
              rowWidth={5}
          />
          <br /><b>You can enter any string on a guess that has some legal word in it. You don't necessarily need to know the word.</b>

      </p>
      <hr />      
      <p>
        <h1>Contact info</h1>
        You can send me an <a href="mailto:kellydornhaus@gmail.com">email</a> about whatever is on your mind.<br/>
      </p>
      {importLink}
      <p>
      </p>
    </div>
  );
}
